export * from './DetailPage';
export * from './NewDetailPage';
